// Module
var code = "<div ref=\"container\" class=\"d-flex h-100 gap-2 p-4\">\n    <cjs-day-agenda ref=\"myAgenda\" class=\"p-2 border w-50\"></cjs-day-agenda>\n    <div class=\"d-flex flex-column p-2 border w-50\">\n        <h4 ref=\"myRdv\"></h4>\n        <hr />\n        <div ref=\"appointments\"></div>\n    </div>\n\n</div>";
// Exports
module.exports = code;